import { render, staticRenderFns } from "./ComponentTable.vue?vue&type=template&id=2ee227d0&scoped=true"
import script from "./ComponentTable.vue?vue&type=script&lang=js"
export * from "./ComponentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee227d0",
  null
  
)

export default component.exports